import React, { useContext, useMemo } from "react";
import { string, bool, func, oneOf } from "prop-types";
import {
  AutocompleteDropdown,
  CommonDropdown,
  SimpleDropdown,
} from "@/components";
import { getMonthsArray } from "@/utils";
import { useTextDomainContext } from "@/app/providers";

export const MonthsDropdown = (props: any) => {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);

  const showAll = Boolean(props.showAll);
  const options = useMemo(
    () => getMonthsArray(gettext, showAll),
    [gettext, showAll],
  );

  return (
    <>
      {props.visualStyle === "autoComplete" && (
        <AutocompleteDropdown
          options={options}
          componentLabel={props.componentLabel || ""}
          showAll={false}
          defaultValue={props.defaultValue}
          onChange={props.onChange}
          size="small"
        />
      )}

      {props.visualStyle === "simple" && (
        <SimpleDropdown
          options={options}
          componentLabel={props.componentLabel || ""}
          showAll={false}
          defaultValue={props.defaultValue}
          onChange={props.onChange}
        />
      )}

      {props.visualStyle === "old" && (
        <CommonDropdown
          options={options}
          componentLabel={props.componentLabel || ""}
          showAll={false}
          defaultValue={props.defaultValue}
          onChange={props.onChange}
        />
      )}
    </>
  );
};

MonthsDropdown.propTypes = {
  componentLabel: string,
  defaultValue: string,
  showAll: bool,
  onChange: func,
  visualStyle: oneOf(["autoComplete", "autoCompleteMulti", "simple", "old"])
    .isRequired,
};
